import type { ReactNode } from "react";
import { cx } from "./cx";

/** Lista vazia: diz o porquê e o que fazer. Sem ilustração. */
export function Vazio({ titulo, children, acao }: { titulo: string; children?: ReactNode; acao?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-1 rounded-cartao fio-tracejado px-6 py-8 text-center">
      <p className="text-corpo font-medium text-texto-1">{titulo}</p>
      {children && <p className="max-w-sm text-meta text-texto-3">{children}</p>}
      {acao && <div className="mt-3">{acao}</div>}
    </div>
  );
}

/** Esqueleto de carregamento: a forma do que vem, na altura de uma linha. */
export function Esqueleto({ linhas = 4, className }: { linhas?: number; className?: string }) {
  return (
    <div aria-busy aria-label="Carregando" className={cx("flex flex-col gap-1", className)}>
      {Array.from({ length: linhas }, (_, i) => <div key={i} className="h-8 animate-pulse rounded-controle bg-superficie-2" />)}
    </div>
  );
}

/** Erro de carregamento, com como tentar de novo. */
export function Falha({ mensagem, aoTentar }: { mensagem: string; aoTentar?: () => void }) {
  return (
    <div role="alert" className="flex flex-wrap items-center justify-between gap-3 rounded-controle bg-alerta-fundo px-3 py-2 text-corpo text-alerta">
      <span>{mensagem}</span>
      {aoTentar && <button type="button" onClick={aoTentar} className="cursor-pointer font-medium underline underline-offset-2">Tentar de novo</button>}
    </div>
  );
}
